import React from 'react';
import { downloadUserAttachment } from '../../api/Api';
import { useLoadingContext } from '../../contexts/LoadingContext';
import { getFileType } from '../../utilities/parsers';
import Divider from '../Divider';

const AttachmentsTab = ({
  orderNumber,
  order,
  fileToUpload,
  setFileToUpload,
  fileDescription,
  setFileDescription,
  handleUpload,
  files,
  onClickSaveChanges,
  profile,
  orderId,
}) => {
  const { setLoading } = useLoadingContext();

  const downloadFile = async (e, file) => {
    e.preventDefault();
    setLoading(true);
    const { name, media } = file;
    const response = await downloadUserAttachment(orderId, {
      file,
      name,
      content_type: getFileType(name),
      media,
      orderId,
    });
    if (response.ok) {
      const blob = await response.blob();
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
    } else {
      console.log('Response not ok', response);
    }
    setLoading(false);
    // /** Aca arranca a bajar */
  };

  return (
    <section className="section" id="attachmentsTab" key="attachmentsTab">
      <div className="columns mb-0 pb-0">
        <div className="column is-one-third">
          <div className="field">
            <label className="label is-normal">Número de Órden:</label>
            <div className="field-body">
              <div className="field">
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="text"
                    placeholder=""
                    disabled={true}
                    value={orderNumber[0]}
                  />
                </div>
              </div>
              <div className="field">
                <div className="control is-expanded">
                  <input
                    className="input"
                    type="text"
                    placeholder=""
                    disabled={true}
                    value={orderNumber[1]}
                  />
                </div>
              </div>
              <div className="field">
                <p className="control is-expanded">
                  <input
                    className="input"
                    type="text"
                    placeholder=""
                    disabled={true}
                    value={orderNumber[2]}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="column is-one-third">
          <div className="field">
            <label className="label is-normal">Anunciante:</label>
            <div className="field-body">
              <div className="field">
                <p className="control is-expanded">
                  <input
                    className="input"
                    type="text"
                    placeholder=""
                    disabled={true}
                    value={order['Anunciante']}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="column is-one-fifth">
          {!profile.is_admin && (
            <div className="field">
              <label className="label is-normal">&nbsp;</label>
              <div className="field-body">
                <div className="field">
                  <div className="control is-expanded">
                    <div className="button is-primary" onClick={onClickSaveChanges}>
                      Guardar Cambios
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <h3 className="subtitle">Adjuntos</h3>
      {!profile.is_admin && (
        <section>
        <Divider />
        <div className="columns mb-0 pb-0">
          <div className="column is-one-third">
            {!profile.is_admin && (
              <div className="field">
                <div className="field-body">
                  <div className="field">
                    <div className="control is-expanded">
                      <label htmlFor="">Adjuntar Archivo</label>
                      <div className="file has-name is-dark">
                        <label className="file-label">
                          <input
                            className="file-input"
                            type="file"
                            name="resume"
                            onChange={(e) => {
                              e.preventDefault();
                              setFileToUpload(e.target.files)
                              } 
                          }
                          />
                          <span className="file-cta">
                            <span className="file-icon">
                              <i className="fas fa-upload"></i>
                            </span>
                            <span className="file-label">
                              {fileToUpload.length > 0
                                ? fileToUpload[0]?.name
                                : 'Seleccionar Archivo'}
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <p className="control is-expanded">
                      <label htmlFor="">Tipo de Archivo</label>
                      <input
                        className="input"
                        type="text"
                        placeholder=""
                        disabled={true}
                        value={getFileType(fileToUpload[0]?.name)}
                      />
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="column is-half">
            <div className="field">
              <p className="control is-expanded">
                <label htmlFor="">Descripcion</label>
                <input
                  autoFocus
                  className="input"
                  type="text"
                  placeholder="Descripción"
                  disabled={fileToUpload < 1}
                  value={fileDescription}
                  onChange={(e) => {
                    e.preventDefault();
                    setFileDescription(e.target.value);
                  }}
                />
              </p>
            </div>
          </div>
          {!profile.is_admin && (
            <div className="column is-one-fourth">
              <div className="field">
                <label htmlFor="">&nbsp;</label>
                <p className="control is-expanded">
                  <button
                    className="button is-dark"
                    disabled={!fileToUpload || fileToUpload.length === 0}
                    onClick={() => handleUpload(fileToUpload, fileDescription, 4)}
                  >
                    Subir Archivo
                  </button>
                </p>
              </div>
            </div>
          )}
        </div>
        <Divider />
      </section>
      )}
      <table className="table is-bordered is-fullwidth pr-0 mr-0 is-hoverable">
        <thead>
          <tr>
            <th>Archivos Adjuntos</th>
            <th>Tipo Archivo</th>
            <th>Descripcion</th>
            <th>Medio</th>
          </tr>
        </thead>
        <tbody>
          {files.map((file, index) => (
            <tr key={index}>
              {/* <td><a href={`${file.url}`}>{file.name}</a></td> */}
              <td>
                <button className="button is-ghost" onClick={(e) => downloadFile(e, file)}>
                  {file.name}
                </button>
              </td>
              <td>{getFileType(file?.name)}</td>
              <td>{file.description}</td>
              <td>{file.media}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Divider />
    </section>
  );
};

export default AttachmentsTab;
